/** Breakpoint aligned with admin.css / Header.vue responsive shell behavior. */
export const SHELL_MOBILE_BREAKPOINT = 991;

export function isShellDesktopViewport() {
    return window.innerWidth > SHELL_MOBILE_BREAKPOINT;
}

export function isSidebarCollapsed() {
    const sideElement = document.getElementById('nav-page-sidebar');
    return !!sideElement && sideElement.classList.contains('close_icon');
}

export function expandSidebarShell() {
    const headerElement = document.getElementById('top-page-header');
    const sideElement = document.getElementById('nav-page-sidebar');
    if (!headerElement || !sideElement) {
        return false;
    }

    sideElement.classList.remove('close_icon');
    headerElement.classList.remove('close_icon');
    return true;
}

/**
 * Sync sidebar + header collapsed state from current viewport width.
 * @returns {boolean} true when both shell elements were found and updated
 */
export function syncSidebarShellState() {
    const headerElement = document.getElementById('top-page-header');
    const sideElement = document.getElementById('nav-page-sidebar');
    if (!headerElement || !sideElement) {
        return false;
    }

    const isMobile = window.innerWidth <= SHELL_MOBILE_BREAKPOINT;
    if (isMobile) {
        sideElement.classList.add('close_icon');
        headerElement.classList.add('close_icon');
    } else {
        sideElement.classList.remove('close_icon');
        headerElement.classList.remove('close_icon');
    }
    return true;
}

/**
 * Run sync after Vue shell (Header + Sidebar) has mounted — retries until DOM is ready.
 */
export function initShellLayoutWhenReady(maxAttempts = 30) {
    let attempts = 0;

    const trySync = () => {
        if (syncSidebarShellState() || attempts >= maxAttempts) {
            return;
        }
        attempts += 1;
        requestAnimationFrame(trySync);
    };

    trySync();
}
